<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dSSVWg/tc-custom/9781640808669.jpg?1717864812279" alt="This image is the cover for the book Hiding In Plain Sight, Camp H.O.W.L."/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hiding In Plain Sight, Camp H.O.W.L.
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>A Camp H.O.W.L. Novel</i></b></p><p>Happily ever after is right under their noses.</p><p>Harris has been keeping a big secret for years—his unrequited mate bond with his best friend, Jackson. He’s convinced himself that having Jackson in his life is enough. That, and his work at Camp H.O.W.L., keeps him going.</p><p>Things get complicated when Jackson applies for a high-ranking Tribunal job in New York City—far from Camp H.O.W.L. The position requires he relinquish all Pack bonds… and that’s when his wolf decides to choose a mate. Suddenly Jackson sees his best friend in a sizzling new light.</p><p>Their chemistry is through the roof, but they're setting themselves up for broken hearts—and broken bonds—if Jackson can't figure out a way to balance his career and the love that’s just been waiting for him to take notice. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bru Baker
      </h2>
      
      <p class="authorDescription body article">Bru Baker got her first taste of life as a writer at the tender age of four, when she started publishing a weekly newspaper for her family. What they called nosiness she called a nose for news, and no one was surprised when she ended up with degrees in journalism and political science and started a career in journalism.<BR />Bru spent more than a decade writing for newspapers before making the jump to fiction. She now works in reference and readers&rsquo; advisory in a Midwestern library, though she still finds it hard to believe someone&rsquo;s willing to pay her to talk about books all day. Most evenings you can find her curled up with a book or her laptop. Whether it&rsquo;s creating her own characters or getting caught up in someone else&rsquo;s, there&rsquo;s no denying that Bru is happiest when she&rsquo;s engrossed in a story. She and her husband have two children, which means a lot of her books get written from the sidelines of various sports practices.<BR />Website: <a href="https://www.google.com/url?q=http://www.bru-baker.com&amp;sa=D&amp;source=calendar&amp;ust=1667074703644793&amp;usg=AOvVaw0ddYdSJOH-6NMx_-BJGsiP" target="_blank">www.bru-baker.com</a><BR />Blog: <a href="https://www.google.com/url?q=http://www.bru-baker.blogspot.com&amp;sa=D&amp;source=calendar&amp;ust=1667074703644793&amp;usg=AOvVaw3otR13Q1UTZF1laReE9PCf" target="_blank">www.bru-baker.blogspot.com</a><BR />Twitter: @bru_baker<BR />Facebook: <a href="https://www.google.com/url?q=http://www.facebook.com/bru.baker79&amp;sa=D&amp;source=calendar&amp;ust=1667074703644793&amp;usg=AOvVaw2XJ-qu1yG9GARdWNkasQVw" target="_blank">www.facebook.com/bru.baker79</a><BR />Goodreads: <a href="https://www.google.com/url?q=http://www.goodreads.com/author/show/6608093.Bru_Baker&amp;sa=D&amp;source=calendar&amp;ust=1667074703644793&amp;usg=AOvVaw2gImEvB5BYSEyZGOxqsiLR" target="_blank">www.goodreads.com/author/show/6608093.Bru_Baker</a><BR />Email: <a href="mailto:bru@bru-baker.com" target="_blank">bru@bru-baker.com</a></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6373fb20